var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnorderedList = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.334 3.372a.5.5 0 1 0-.669-.744L4.673 5.323 3.354 4.136a.5.5 0 0 0-.669.744l1.653 1.488a.5.5 0 0 0 .67 0zM10.5 5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.5-.5m-6.56 5.94a1.5 1.5 0 1 1 2.12 2.12 1.5 1.5 0 0 1-2.12-2.12m-.708-.708a2.5 2.5 0 1 1 3.535 3.535 2.5 2.5 0 0 1-3.535-3.535M11 11.5a.5.5 0 1 0 0 1h10a.5.5 0 0 0 0-1zm-.5 7.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.5-.5m-6.56-1.06a1.5 1.5 0 1 1 2.12 2.12 1.5 1.5 0 0 1-2.12-2.12m-.708-.708a2.5 2.5 0 1 1 3.535 3.535 2.5 2.5 0 0 1-3.535-3.535",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnorderedList);
export default ForwardRef;